/**
 * @generated SignedSource<<b19bc89b2bc397fecbe80008d4299785>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_Transcript_viewer$data = {
  readonly account: {
    readonly allowAiFeatures: boolean;
    readonly allowMeetingRecordingRedaction: boolean;
    readonly billingAccount: {
      readonly hasAccessToPrivateRecapComments: boolean;
      readonly hasAccessToRecapComments: boolean;
      readonly hasAccessToRedaction: boolean;
    };
  };
  readonly " $fragmentType": "TranscriptPanel_Transcript_viewer";
};
export type TranscriptPanel_Transcript_viewer$key = {
  readonly " $data"?: TranscriptPanel_Transcript_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_Transcript_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptPanel_Transcript_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAiFeatures",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowMeetingRecordingRedaction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToRedaction",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "redaction"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"redaction\")"
            },
            {
              "alias": "hasAccessToRecapComments",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "recap_comments"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"recap_comments\")"
            },
            {
              "alias": "hasAccessToPrivateRecapComments",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "recap_private_comments"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"recap_private_comments\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d381943e76d14095abd13b142c2fb2f2";

export default node;
